<template>
    <el-dialog
            title="信息"
            :visible="true"
            width="60%"
            :before-close="handleClose">
        <el-button type="primary">导出</el-button>
        <el-table
                ref="multipleTable"
                v-loading="loading"
                :data="tableData"
                border
                height="350"
                style="width: 100%;margin-top: 20px">
            <el-table-column
                    label="批号"
                    width="80"
                    type="index"
                    fixed
            >
            </el-table-column>
            <el-table-column
                    prop="instockCode"
                    label="入库单号"
                    width="180"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="pCode"
                    label="规格"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="num"
                    label="生产日期"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="num"
                    label="有效期至"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="num"
                    label="入库数量"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="num"
                    label="出库数量"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="num"
                    label="退货数量"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="num"
                    label="剩余数量"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
    </el-dialog>
</template>

<script>
    export default {
        name: "stock-detail-dialog",
        data() {
            return {
                loading:false,
                tableData:[],
                //分页
                pageNo: 1,//页码
                pageSize: 20,//每页现实的条数
                totalSize: 0,//总条数
            }
        },
        methods: {
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;

            },
            handleCurrentChange(val) {
                this.pageNo = val;

            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
        },
    }
</script>

<style lang="scss" scoped>

</style>